import "./Technology.css";

function Technology() {

const techs=[
"React JS",
"Node JS",
"PHP",
"MySQL",
"Bootstrap",
"HTML5",
"CSS3",
"JavaScript",
"Java",
"Android",
"REST API",
"GitHub"
];

return(

<section className="technology">

<div className="container">

<div className="section-title">

<h5>OUR TECHNOLOGIES</h5>

<h2>

Technologies We Work With

</h2>

<p>

Modern technologies for scalable and secure applications.

</p>

</div>

<div className="tech-grid">

{

techs.map((tech,index)=>(

<div className="tech-box" key={index}>

{tech}

</div>

))

}

</div>

</div>

</section>

)

}

export default Technology;